import React from 'react';
import { Link } from 'react-router-dom';
import Contact from './contact';
import Seo from './Seo';

const Home = () => {
  return (
    <main>
      <Seo
        title="Ayan Nayyer"
        description="Portfolio of Ayan Nayyer, a software developer and data scientist building full-stack web apps, AI/ML systems, and iOS apps. Projects, blog, and resume."
        path="/"
      />
      <section className="landing-page">
        <div className="landing-content">
          <h1 className="name-title modak-regular">
            Ayan<br />Nayyer
          </h1>
          <p className="subtitle">Data Science | Web Dev | Literature</p>
          <nav className="home-cta" aria-label="Main sections">
            <Link to="/projects" className="cta-button">Projects</Link>
            <Link to="/blogs" className="cta-button">Blog</Link>
            <a href="/Resume.pdf" target="_blank" rel="noopener noreferrer" className="cta-button">Resume</a>
          </nav>
        </div>
      </section>
      <div className="content-wrapper">

        <Contact />
      </div>
    </main>
  );
};

export default Home;
